import { isJsonObject, type JsonObject } from "../../api/http/jsonDecoding";

/** The exact version of the more general item a process item is a kind of (`kind_of`,
 * processes.md P-19), or `null`. A step keeps its fields one level down, in `definition`. */
export function itemKindOf(definition: JsonObject | null): string | null {
  if (definition === null) {
    return null;
  }
  const nested = definition["definition"];
  const fields = definition["kind"] === "step" && isJsonObject(nested) ? nested : definition;
  const general = fields["kind_of"];
  return typeof general === "string" ? general : null;
}
